module.exports = __webpack_public_path__ + "static/media/furniture-2.312bfd7f.jpg";